<template>
  <v-layout :class="styles" column>
    <v-menu transition="slide-y-transition" top>
      <template v-slot:activator="{ on }">
        <p class="ma-0 px-4">
          <a v-on="on" class="incidentTitle">
            【障害復旧情報】編集操作の保存に失敗する問題について
          </a>
        </p>
      </template>
      <v-card class="pa-2" style="width: 500px">
        <v-subheader :class="[headerStyles, 'px-2']">
          【障害復旧情報】編集操作の保存に失敗する問題について
        </v-subheader>
        <p class="ma-2 incidentContent">
          現在、案件およびキャンペーン等の編集の保存に失敗する障害が7月9日(火)
          21:00頃 - 7月10日(水) 11:20頃 まで発生しておりました。<br />
          なお、現在は本障害は復旧しております。
          ご迷惑をおかけし、大変申し訳ございませんでした。
        </p>
        <!-- <v-subheader :class="[headerStyles, 'px-2']">
          マップレポート機能アップデートのお知らせ
        </v-subheader>
        <p class="ma-2 incidentContent">
          2023年9月1日以降に発行されるマップレポートより、マップレポート機能をアップデートいたします。<br />
          マップレポートのデータソースが増えるため、従来のマップレポートに比べてImpエリア、Click地点が大幅に増加し表示されるようになります。<br />
          また、インフィード広告、動画広告においてもマップレポートの対応が可能になります。<br />
          （このアップデートは配信への影響・変動はありません。）<br />
          詳細は
          <a
            href="https://geologic.atlassian.net/wiki/spaces/GLAD/pages/2680389633"
            target="_blank"
            rel="noopener noreferrer"
            >こちら</a
          >をご確認ください。
        </p> -->
        <AppButtonOk small>閉じる</AppButtonOk>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import { css } from 'emotion'
export default {
  name: 'HolidaysInformation',
  computed: {
    styles() {
      return css`
        display: flex;
        align-items: flex-start;
        justify-content: center;
        font-size: 12px;
        overflow: hidden;
      `
    },
    headerStyles() {
      return css`
        font-size: 16px !important;
      `
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    },
  },
}
</script>
<style>
.incidentTitle {
  color: #ff4500 !important;
  font-size: 14px;
}
.incidentContent {
  font-size: 14px;
}
</style>
